import { createLogic } from 'redux-logic'
import { map, take } from 'rxjs/operators'
import * as constants from '../constants'
import { normalize } from '@engine/dependencies'
import Comps from '@engine/comps'

export const fetchImagesPropertyList = createLogic({
  type: constants.CREATE_PROJECT_FROM_LIST.ACTION,
  processOptions: {
    successType: constants.CREATE_PROJECT_FROM_LIST.FULFILLED,
    failType: constants.CREATE_PROJECT_FROM_LIST.REJECTED
  },
  process({ http, action, getState }) {
    const state = getState()
    const listInfo = Comps.selectors.comps.listInfo(state) || state.listInfo
    const propertyIdList = listInfo?.compsList && listInfo?.compsList?.reduce((prev, cur) => prev.concat(cur.omniViewPropertyId), [])

    return http
      .post('/comps/photos/query', { propertyIdList })
      .pipe(
        take(1),
        map(http.getBody),
        map(res => ({
          listInfo: normalize.updateListInfo(listInfo, res),
          projectType: action.payload.projectType,
          listName: action.payload.listName
        }))
      )
  }
})
